import styled from '@emotion/styled';

interface FooterProps {
  footerShown: boolean;
}

export const Footer = styled.div<FooterProps>(({ footerShown = false }) => ({
  display: footerShown ? 'block' : 'none',
}));
